// src/components/Plans/PlanPagination.tsx
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface Props {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  itemsPerPage: number;
}

const PlanPagination: React.FC<Props> = ({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  itemsPerPage,
}) => (
  <div className="flex justify-between items-center mt-6 text-gray-700 dark:text-gray-300">
    <p className="text-sm">
      Showing{" "}
      <span className="font-medium">
        {(currentPage - 1) * itemsPerPage + 1}
      </span>{" "}
      to{" "}
      <span className="font-medium">
        {Math.min(currentPage * itemsPerPage, totalItems)}
      </span>{" "}
      of <span className="font-medium">{totalItems}</span> results
    </p>
    <div className="flex items-center gap-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="p-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      <span className="px-3 py-1 text-sm bg-indigo-100 dark:bg-indigo-900/50 text-indigo-700 dark:text-indigo-300 rounded-md font-medium">
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="p-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-40"
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  </div>
);

export default PlanPagination;
